function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { DrmProvider, DrmType } from '../core/player/playout-data';
import { stringToUnit8 } from '../utils/utf8Utils';
import { ContentType } from './drm.enums';
export { ContentType } from './drm.enums';
var _obj, _obj1, _obj2, _obj3;
/*
     *  This should never be passed by the SDK. It's required by BuyDRM and
     *  it should be calculated and attached by a yet-to-be-implemented DRM proxy.
     *  Please see https://github.com/sky-uk/core-video-team/issues/9602#issuecomment-1047987562 for more details.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Content type of body is dependent on player
export var headersByDrmType = (_obj3 = {}, _define_property(_obj3, DrmType.Fairplay, (_obj = {}, _define_property(_obj, DrmProvider.Ovp, {
    /*
             *  OVPs /drm/playready/acquirelicense fails with a CORS error on the OPTIONS
             *  call when Content-Type is not provided or if any custom headers are set.
             *  Adding/removing these headers removes the need for the pre-flight call.
             */ 'Content-Type': ContentType.application
}), _define_property(_obj, DrmProvider.Keyos, {
    'Content-Type': ContentType.text
}), _obj)), _define_property(_obj3, DrmType.Widevine, (_obj1 = {}, _define_property(_obj1, DrmProvider.Ovp, {
    'Content-Type': ContentType.text
}), _define_property(_obj1, DrmProvider.Keyos, {
    'Content-Type': ContentType.applicationStream
}), _obj1)), _define_property(_obj3, DrmType.PlayReady, (_obj2 = {}, _define_property(_obj2, DrmProvider.Ovp, {
    'Content-Type': ContentType.text
}), _define_property(_obj2, DrmProvider.Keyos, {
    'Content-Type': ContentType.textXml
}), _obj2)), _obj3);
var _obj4;
var customBodyParsersByDrmType = _define_property({}, DrmType.Fairplay, (_obj4 = {}, _define_property(_obj4, DrmProvider.Keyos, {
    request: function(body, contentId) {
        var message = new Uint8Array(body);
        var base64Payload = shaka.util.Uint8ArrayUtils.toStandardBase64(message);
        return "spc=".concat(base64Payload, "&assetId=").concat(contentId);
    },
    response: function(data) {
        var responseText = shaka.util.StringUtils.fromUTF8(data).trim();
        var raw = self.atob(responseText);
        return stringToUnit8(raw);
    }
}), _define_property(_obj4, DrmProvider.Ovp, {
    request: function(body, contentId) {
        var _String;
        var message = new Uint8Array(body);
        return "spc=".concat(btoa((_String = String).fromCharCode.apply(_String, _to_consumable_array(message))).replace(/\+/g, '-').replace(/\//g, '_'), "&assetId=").concat(encodeURIComponent(contentId));
    },
    response: function(data) {
        var responseText = shaka.util.StringUtils.fromUTF8(data).trim();
        var ckc = JSON.parse(responseText).ckc;
        var raw = self.atob(ckc);
        return stringToUnit8(raw);
    }
}), _obj4));
export var DrmNetworkFilter = /*#__PURE__*/ function() {
    "use strict";
    function DrmNetworkFilter(drmType) {
        var provider = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DrmProvider.Ovp, logger = arguments.length > 2 ? arguments[2] : void 0;
        _class_call_check(this, DrmNetworkFilter);
        _define_property(this, "drmType", void 0);
        _define_property(this, "provider", void 0);
        _define_property(this, "logger", void 0);
        this.drmType = drmType;
        this.provider = provider;
        this.logger = logger;
    }
    _create_class(DrmNetworkFilter, [
        {
            key: "getHeaders",
            value: function getHeaders() {
                var _headersByDrmType_this_drmType;
                var headers = ((_headersByDrmType_this_drmType = headersByDrmType[this.drmType]) === null || _headersByDrmType_this_drmType === void 0 ? void 0 : _headersByDrmType_this_drmType[this.provider]) || {};
                if (Object.prototype.hasOwnProperty.call(headersByDrmType, this.drmType)) {
                    this.logger.warn("Forcing license request Content-Type header to ".concat(headers['Content-Type'], " for ").concat(this.drmType, " support and ").concat(this.provider, " provider"));
                }
                return headers;
            }
        },
        {
            key: "parseRequestBody",
            value: // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Content type of body is dependent on player
            function parseRequestBody(body, contentId) {
                var _customBodyParsersByDrmType_this_drmType_this_provider, _customBodyParsersByDrmType_this_drmType;
                return ((_customBodyParsersByDrmType_this_drmType = customBodyParsersByDrmType[this.drmType]) === null || _customBodyParsersByDrmType_this_drmType === void 0 ? void 0 : (_customBodyParsersByDrmType_this_drmType_this_provider = _customBodyParsersByDrmType_this_drmType[this.provider]) === null || _customBodyParsersByDrmType_this_drmType_this_provider === void 0 ? void 0 : _customBodyParsersByDrmType_this_drmType_this_provider.request(body, contentId)) || body;
            }
        },
        {
            key: "parseResponseBody",
            value: function parseResponseBody(data) {
                var _customBodyParsersByDrmType_this_drmType_this_provider, _customBodyParsersByDrmType_this_drmType;
                return ((_customBodyParsersByDrmType_this_drmType = customBodyParsersByDrmType[this.drmType]) === null || _customBodyParsersByDrmType_this_drmType === void 0 ? void 0 : (_customBodyParsersByDrmType_this_drmType_this_provider = _customBodyParsersByDrmType_this_drmType[this.provider]) === null || _customBodyParsersByDrmType_this_drmType_this_provider === void 0 ? void 0 : _customBodyParsersByDrmType_this_drmType_this_provider.response(data)) || data;
            }
        }
    ]);
    return DrmNetworkFilter;
}();

//# sourceMappingURL=drm-network-filter.js.map